import React from "react";

const RetractionPolicy = () => {
  return (
    <React.Fragment>
      <h1>Retraction & Correction Policies</h1>
      <h2>
        <strong>Retractions</strong>
      </h2>
      <p>
        CJoE reserves the right to retract articles that are found to be plagiarized or fraudulent
        (e.g. containing data manipulation or misrepresentation) or in serious breach of one or more
        of our policies. For more information on our process for dealing with scientific misconduct,{" "}
        <a
          href="/journal/engineering/guide#!/policies-and-procedures/plagiarism-misconduct-and-ethics"
          target="_blank"
          rel="noopener"
        >
          please refer to the Publication Ethics and Scientific Misconduct section
        </a>
        .
      </p>
      <h2>
        <strong>Corrections</strong>
      </h2>
      <p>
        CJoE publishes corrections to address errors of scientific fact in its published articles.
        Errors that invalidate the work (typically by affecting the results and conclusions) are not
        eligible for correction and will instead result in article retraction.
      </p>
      <p>
        <strong>Note:</strong> CJoE only publishes minor corrections that do not alter the main
        results or reproducibility of the research, as determined by the editorial staff.
      </p>
      <p>
        <strong>
          Corrections related to author institutional affiliation errors will be considered at the
          discretion of the editorial staff.
        </strong>
      </p>
      <p>Formal correction notices are published and linked to the corrected article.</p>
    </React.Fragment>
  );
};

export default RetractionPolicy;
